/**
 * メモに Todo を入れるときのダイアログ。カレンダーの追加ダイアログ (SlotCreateDialog) を日時なしで使う。
 */

import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

import { listTodos } from '@/api/services/todo'
import type { TodoResponse } from '@/api/types/todo'
import { SlotCreateDialog } from '@/pages/todo/SlotCreateDialog'

type Props = {
  onCreate: (title: string, project: string | null) => Promise<void>
  onPick: (todo: TodoResponse) => void
  onClose: () => void
}

export function TodoInsertDialog({ onCreate, onPick, onClose }: Props) {
  const [openTodos, setOpenTodos] = useState<TodoResponse[]>([])

  useEffect(() => {
    let cancelled = false
    listTodos({ include_done: false, limit: 500 })
      .then((list) => {
        if (!cancelled) setOpenTodos(list)
      })
      .catch((err) => console.warn('[todo-link] failed to load todos', err))
    return () => {
      cancelled = true
    }
  }, [])

  // エディタの DOM 内に置くと ProseMirror がクリックを拾うため body に出す
  return createPortal(
    <SlotCreateDialog
      hiddenModes={['event']}
      existingActionLabel="挿入"
      onClose={onClose}
      onCreateTask={onCreate}
      onCreateEvent={async () => {}}
      onScheduleExisting={async (todoId) => {
        const picked = openTodos.find((t) => t.id === todoId)
        if (picked) onPick(picked)
      }}
      todos={openTodos}
    />,
    document.body,
  )
}
